import { EVENT_LISTENERS } from '../globals';
import { TGetEventListenersOfAudioNodeFunction } from '../types';
import { getValueForKey } from './get-value-for-key';

export const getEventListenersOfAudioNode: TGetEventListenersOfAudioNodeFunction = (audioNode) => {
    return getValueForKey(EVENT_LISTENERS, audioNode);
};
